export default __webpack_public_path__ + "static/media/Group 254.18e621d8.svg";